import { render, staticRenderFns } from "./MentorMessages.vue?vue&type=template&id=508ce3bf&"
import script from "./MentorMessages.vue?vue&type=script&lang=js&"
export * from "./MentorMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports